export default "__VITE_ASSET__d454104b__"